import { render, staticRenderFns } from "./PortfoliosSelect.vue?vue&type=template&id=63cad576&scoped=true&"
import script from "./PortfoliosSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortfoliosSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cad576",
  null
  
)

export default component.exports